export enum CourseType {
  JUNO = 'juno',
  SCORM = 'scorm',
}

export const CourseTypeMap = {
  [CourseType.JUNO]: 'Create a Course',
  [CourseType.SCORM]: 'Import a SCORM file',
};
